import {t} from '@lingui/core/macro';

import {IColumn} from 'shared/ui/Table/Table';

export function getHttpMonitorLogColumns(): IColumn[] {
    return [
        {label: t`Результат`},
        {label: t`Время`},
        {label: t`Код ответа`},
        {label: t`Время отклика, мс`},
        {label: t`Страна/Локация агента`},
        {label: t`IP агента`},
    ];
}

export function getHttpMonitorLogTitle(name = ''): string {
    return `${t`Журнал мониторинга`} ${name} | ${t`Overseer`}`;
}

export function stripMonitorUrlScheme(name?: string): string | undefined {
    return name && name.replace(/^https?:\/\//, '').replace(/\/$/, '');
}
